import http from 'axios'
import {formatFiltresToAxiosParams} from './utils/filtres.utils'

export default {
  getGraphesComparaisonConstruisibles: (codeGraineRs1) => {
    return http.get(`/web/v1/graphe-composition-qualite?codeGraineRs3=${codeGraineRs1}`)
  },
  getComparaisonQualitePS: (username, anneeRecolte, codeGraineRs1, filtres) => {
    return http.get(`/web/v1/${username}/graphe-composition-qualite/ps?anneeRecolte=${anneeRecolte}&codeGraineRs3=${codeGraineRs1}&${formatFiltresToAxiosParams(filtres)}`)
  },
  getComparaisonQualiteProteine: (username, anneeRecolte, codeGraineRs1, filtres) => {
    return http.get(`/web/v1/${username}/graphe-composition-qualite/proteine?anneeRecolte=${anneeRecolte}&codeGraineRs3=${codeGraineRs1}&${formatFiltresToAxiosParams(filtres)}`)
  },
  getComparaisonQualiteHumidite: (username, anneeRecolte, codeGraineRs1, filtres) => {
    return http.get(`/web/v1/${username}/graphe-composition-qualite/humidite?anneeRecolte=${anneeRecolte}&codeGraineRs3=${codeGraineRs1}&${formatFiltresToAxiosParams(filtres)}`)
  }
}
